export enum PackageSizeCode {
  XSmall = 'X_SMALL',
  Small = 'SMALL',
  Medium = 'MEDIUM',
  Large = 'LARGE',
  XLarge = 'X_LARGE',
  Custom = 'CUSTOM',
  NoShipping = 'NO_SHIPPING',
  HeavySmall = 'HEAVY_SMALL',
  HeavyMedium = 'HEAVY_MEDIUM',
  HeavyLarge = 'HEAVY_LARGE',
  HeavyBulkySmall = 'HEAVY_BULKY_SMALL',
  HeavyBulkyMedium = 'HEAVY_BULKY_MEDIUM',
  HeavyBulkyLarge = 'HEAVY_BULKY_LARGE',
}
